import { API_URL } from '../../../components/config/BaseUrl';

export const SEARCH_CALLS_WITH_DATE_URL = `${API_URL}/wificall/recentCalls`;
export const GET_CALLS_COUNT_FROM_DATE_URL = `${API_URL}/wificall/recentCalls/count`;
export const DOWNLOAD_RECORDING_URL = `https://myaccount.wificall.ng/download.php?recordfile=`;
export const DOWNLOAD_RECORDING_URL_BUSINESS = `https://myaccount.wificall.ng/downloadbusiness.php?recordfile=`;
export const GET_CALLS_URL = `${API_URL}/wificall/recentCalls?cardid=`;
export const GENIATECH_URL = `https://legacy.tizeti.com/geniatechapi/index.php`;
